import { SafeResourceUrl } from '@angular/platform-browser';

export enum EntityForImageUpdate {
  ORGANIZATION = 'organization',
  CERTIFICATION = 'certification',
  USER = 'user',
}

export interface EntityImageConfig {
  imageFile: string | SafeResourceUrl;
  originalImageFile: string;
  imageConfiguration: any;
  cropBoxConfiguration?: any;
}

export enum UPLOAD_IMAGE_ACTION {
  UPLOAD,
  EDIT,
  RESET,
}

export const UPLOAD_ENTITY_NAME_MAP = {
  [EntityForImageUpdate.ORGANIZATION]: 'Logo',
  [EntityForImageUpdate.USER]: 'Avatar',
  [EntityForImageUpdate.CERTIFICATION]: 'Credential Logo',
};

export const IMAGE_SIZE_RESTRICTION = {
  minWidth: 144,
  minHeight: 144,
};
